module.exports = __webpack_public_path__ + "static/media/FJ.902a5149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/FJ.svg
// module id = 2150
// module chunks = 7